import adejoke from '../assets/testimonials/adejoke.png';
import musa from '../assets/testimonials/musa.png';
import chioma from '../assets/testimonials/chioma.png';
import emeka from '../assets/testimonials/emeka.png';
import bolanle from '../assets/testimonials/bolanle.png';

export const testimonialsData = [
  {
    id: 1,
    name: 'Adejoke O.',
    role: 'Lagos Entrepreneur',
    text: 'WayaBank has completely transformed how I handle my business finances. The instant transfers and zero hidden fees are a game changer for SMEs in Nigeria.',
    image: adejoke,
    rating: 5
  },
  {
    id: 2,
    name: 'Musa I.',
    role: 'Abuja Business Owner',
    text: 'Finally, a bank that understands the speed of Nigerian business. Bulk transfers are seamless, and I can manage everything right from my phone.',
    image: musa,
    rating: 5
  },
  {
    id: 3,
    name: 'Chioma A.',
    role: 'Enugu Student',
    text: 'As a student, every kobo counts. WayaBank low fees and easy-to-use app make it perfect for my daily needs. Highly recommended!',
    image: chioma,
    rating: 5
  },
  {
    id: 4,
    name: 'Emeka N.',
    role: 'Kano Tech Professional',
    text: 'The UI is clean and the security features give me peace of mind. WayaBank is definitely the future of digital banking in Africa.',
    image: emeka,
    rating: 5
  },
  {
    id: 5,
    name: 'Bolanle S.',
    role: 'Ibadan Retail Trader',
    text: 'I love how I can use USSD when internet is down. It means I never get stranded at the market. WayaBank really cares about everyone.',
    image: bolanle,
    rating: 5
  }
];
